import Api from 'utils/api'

export const fetchInterview = ({ uuid }) => Api.get(['interviews', uuid])

export const patchEvaluation = ({ evaluationData, status, id }) =>
  Api.patch(['interviewevaluations', id], {
    evaluation_data: evaluationData,
    status,
  })

export const deleteEvaluator = ({ uuid }) =>
  Api.delete(['interviewevaluations', uuid])

export const saveEvaluator = ({ email, jobInterview, name }) =>
  Api.post('interviewevaluations', {
    email,
    job_interview: jobInterview,
    name,
  })
